export default {
    API: "https://akitatek.fr",
    Carousel: "https://akitatek.fr/uploads/img/carrousel/",
    Photo: "https://akitatek.fr/uploads/images/annuaire/",
    ServerNode: "https://files.akitatek.fr",
    PhotoBase: "https://akitatek.fr/images/",

}
